import { render, staticRenderFns } from "./vs-form-color.vue?vue&type=template&id=db6ed948&lang=true"
import script from "./vs-form-color.vue?vue&type=script&lang=js"
export * from "./vs-form-color.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports